import { RootState } from '../../../init-store';

let preloadedState: Partial<RootState>;
export const getPreloadedState = () => {
    if (!preloadedState) {
        const preloadedStateElement = document.getElementById('preloaded-state');
        preloadedState = preloadedStateElement ? JSON.parse(preloadedStateElement.innerHTML) : {};
    }
    return preloadedState;
};
